import { Button, Form, Modal } from 'antd';
import React from 'react';
import {changePaymentMethod} from "src/apis/Reporting/ChangePaymentMethod";
import ChangePaymentMethodForm from 'src/components/Reporting/ChangePaymentMethodForm';

interface ILocalProps {
    companyProfileID: number;
    currentPaymentMethod: number;
    customerName: string;
    handleClose: () => void;
    handleSubmit: () => void;
}

interface ILocalState {
    loading: boolean;
    responseMessage: string;
}

class ChangePaymentMethodModal extends React.Component<ILocalProps, ILocalState> {
    public state = { loading: false, responseMessage: '' };

    public formReference: Form | null = null;

    public handleClose = () => {
        this.props.handleClose();
    };

    public handleSubmit = () => {
        const { companyProfileID } = this.props;
        if (this.formReference !== null && this.formReference.props.form) {
            this.formReference.props.form.validateFields({ force: true }, async (err, values) => {
                if (err) {
                    const message = err.toString() === '[object Object]' ? '' : err.toString();
                    this.setState({ responseMessage: message, loading: false });
                    return;
                }
                this.setState({ loading: true });

                const response = await changePaymentMethod(
                    companyProfileID,
                    values.newPaymentMethod
                );

                this.setState({ responseMessage: response.message, loading: false });
                if (response.success) {
                    this.props.handleSubmit();
                }
            });
        }
    };

    public saveFormRef = (formReference: Form) => {
        this.formReference = formReference;
    };

    public render() {
        const title = 'Change Payment Method for ' + this.props.customerName;
        return (
            <Modal
                closable={false}
                title={title}
                visible={true}
                className="modal"
                footer={[
                    <Button key="close" onClick={this.handleClose} style={{ float: 'left' }}>Close</Button>,
                    <Button key="submit" loading={this.state.loading} onClick={this.handleSubmit} type="primary">Submit</Button>,
                ]}
            >
                <ChangePaymentMethodForm
                    paymentMethod={this.props.currentPaymentMethod === 1024 ? 'cc' : 'invoice'}
                    wrappedComponentRef={this.saveFormRef}
                />
                <span className="errorMessage">{this.state.responseMessage}</span>
            </Modal>
        );
    }
}

export default ChangePaymentMethodModal;
